import Icon, { FONT_SIZES, COLORS } from './Icon'

export { FONT_SIZES, COLORS }

export default Icon
